const ROOT_URL = '/downloads';
const API_URL = '/diazar_suite';

export const APP_ID = 2;
export const COOKIE_NAME = 'diazar-suite'

export const ServicesUrl = {
    autoFirm: `${ROOT_URL}`,
    login: `${ROOT_URL}/login`,
    items: `${ROOT_URL}/files`,
    finish: `${ROOT_URL}/finish`,

    apps: `${API_URL}/aplications/get/${ APP_ID }.json`,
    appsValidate: `${API_URL}/aplications/validate_token/${ APP_ID }.json`,
}